import Promise from 'bluebird';
import _ from 'lodash';
import store from '../../store';
import { OVERVIEW_PANEL_GET_CURRENT, OVERVIEW_PANEL_IS_VISIBLE } from '../../store/modules/overview-panel/types';
import worldMap from '../core/map';
import templates from '../core/templates';

import ColorBrewer from '../core/tools/colorbrewer';
import ColorFlatUI from '../core/tools/colorflatui';
import environment from '../environment';
import Leaflet from './Leaflet';

const LayerControls = (name) => require('../controls').get(name);
const LayerInfo = (name) => require('../info').get(name);
const get = (name, currentMap = worldMap.getCurrent()) => {
    return require('./index').default.get(name, currentMap);
};

const name = 'MarkedArea';

class MarkedAreaLayer {
    constructor (currentMap) {
        const mapId = currentMap._id;

        const onClick = (feature) => {
            if (worldMap.getCurrent()._id === mapId) {
                const status = LayerInfo(name).check(feature.properties.Id) ? 'uncheck' : 'check';
                $(`#MarkedArea-selection-${feature.properties.Id}`).iCheck(status);
            }
        };

        const onSuccess = (featureCollection) => {
            return new Promise((resolve) => {
                LayerControls(name).colorize(featureCollection, get(name, currentMap)).then((fc) => {
                    resolve(fc);
                });
            });
        };

        const onComplete = () => {
            LayerControls(name).show({
                show: false,
                refresh: true
            });

            if (store.getters[OVERVIEW_PANEL_GET_CURRENT] === name && store.getters[OVERVIEW_PANEL_IS_VISIBLE] && LayerControls(name).getControls(mapId).button.overview.enable) {
                LayerControls(name).toggleOverview();
            }
        };

        const layer = new Leaflet.D3Layer();

        const idLayerType = (() => {
            try {
                return environment.get('CONFIG.FILTERS.MARKED_AREA_TYPES')[_.take(_.keys(environment.get('CONFIG.FILTERS.MARKED_AREA_TYPES')), 1)[0]].id;
            } catch (error) {
                return 0;
            }
        })();

        layer.setOptions({
            map: currentMap,
            remote: {
                url: `${environment.get('API_HOST')}/localidade/GetLocation`,
                params: {
                    locationType: idLayerType
                }
            },
            cache: true,
            filter: {
                location: true
            },
            scaleRange: new Leaflet.ZoomLevel(layer, {
                id: idLayerType,
                type: name,
                property: 'locationType'
            }),
            showAll: false,
            expandView: 0.5,
            autofocus: false,
            uniqueField: 'Id',
            sort: 'Nome',
            below: true,
            tagViewportClamp: true,
            manualPaints: LayerControls(name)._manualPaints,
            dblclick: onClick,
            done: onComplete,
            success: onSuccess,
            label: {
                template (properties) {
                    return templates('map-layer-areas-label', properties);
                },
                options: {
                    offset: [12, -40],
                    direction: 'left'
                }
            },
            value: 'Total',
            symbology: {
                type: 'choropleth',
                theme: ColorBrewer.OrRd[9],
                style: {
                    highlight: true,
                    lineJoin: 'round',
                    color: ColorFlatUI.wet_asphalt[1][0],
                    fillColor: 'rgba(0,0,0,0.1)',
                    fillOpacity: 0.2,
                    opacity: 1,
                    weight: 1
                }
            }
        });

        return layer;
    }
}

export default MarkedAreaLayer;



// WEBPACK FOOTER //
// ./src/scripts/layers/MarkedAreaLayer.js